module.exports = __webpack_public_path__ + "static/media/invernesslogonew.f8b74782.png";